import styled from 'styled-components';

export const List = styled.div`
  background: #dfe3e6;
  flex-shrink: 0;
  width: 352px;
  max-width: min(352px, 85vw);
  height: fit-content;
  margin: 10px;
  margin-right: 0;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;

  @media (max-width: 767px) {
    width: 85vw;
    max-width: 352px;
  }
`;

export const ListTitle = styled.div`
  padding: 10px;
  overflow-wrap: break-word;
  word-break: break-word;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  text-align: center;
`;

export const ListBody = styled.div`
  height: fit-content;
  padding: 2px;

  /* Desktop: internal column scroll (kanban) */
  @media (min-width: 992px) {
    max-height: min(60vh, calc(100dvh - 280px));
    overflow-y: auto;
  }

  /* Tablet / mobile: expand fully; page scroll shows all cards */
  @media (max-width: 991px) {
    max-height: none;
    overflow: visible;
  }

  ::-webkit-scrollbar {
    background: white;
    border-radius: 5px;
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #6b808c;
    border-radius: 10px;
  }
`;

export const Toggle = styled.div`
  cursor: pointer;
  padding: 10px;
  color: #6b808c;
  border-radius: 0 0 10px 10px;
  display: flex;
  align-items: center;
  font-weight: 500;

  &:hover {
    background-color: rgba(9, 45, 66, 0.13);
    color: #17394d;
  }
`;
